import './FlyoutHeader.scss';
import { CardHeader, CardTitle } from '@progress/kendo-react-layout';
import { KWELLO_ICON, KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';
import KwelloButton from 'common/components/KwelloButton/KwelloButton';

interface FlyoutHeaderProps {
  title: string;
  subTitle?: string;
  icon?: KWELLO_ICON;
  onCloseClick?: () => void;
  onLeftIconClick?: () => void;
  closeIcon?: boolean;
  actions?: React.ReactNode[];
}

export function FlyoutHeader({
  title,
  subTitle,
  icon,
  onCloseClick,
  onLeftIconClick,
  closeIcon = true,
  actions,
}: Readonly<FlyoutHeaderProps>) {
  return (
    <CardHeader className="flyout-header">
      <CardTitle className="flyout-header-title-container">
        {!!icon && onLeftIconClick && (
          <KwelloButton
            displayOnly={!onLeftIconClick}
            icon={icon}
            size="large"
            fillMode={'link'}
            rounded="large"
            onClick={onLeftIconClick}
          />
        )}
        {!!icon && !onLeftIconClick && (
          <div className="icon-outline">
            <KwelloSvgIcon icon={icon} />
          </div>
        )}
        <div className="flyout-header-title-text">
          <h4 className="flyout-header-title">{title}</h4>
          {subTitle && <p className="flyout-header-subtitle">{subTitle}</p>}
        </div>
        {actions && <div className="flyout-header-actions">{actions}</div>}
        {!!onCloseClick && closeIcon && (
          <KwelloButton
            className="align-self-start close-button"
            icon={KWELLO_ICON.X_CLOSE}
            iconColor="gray"
            size="small"
            rounded="large"
            onClick={onCloseClick}
          />
        )}
      </CardTitle>
    </CardHeader>
  );
}
